import ProtectedRoute from 'components/ProtectedRoute'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import InsightsLabLanding from './Landing'

const InsightsLabReport = () => {
  const merchant = useCurrentMerchant()

  if (!merchant) return null

  return (
    <ProtectedRoute
      component={InsightsLabLanding}
      redirect="/"
      resource="InsightsLab"
      accessType="access"
    />
  )
}

export default InsightsLabReport
